import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  onClick: () => void;
  children: ReactNode;
  isSelected?: boolean;
  className?: string;
};

export default function SelectOption({ onClick, children, isSelected, className }: Props) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={cn(
        "h-[3.125rem] px-5 flex items-center text-16 font-medium",
        isSelected
          ? "text-accent bg-gradient-to-r from-accent-solid/20 to-transparent"
          : "text-white",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
